import APITemplate from '@api/APITemplate'
import { diffTimeMinutes } from '@utils/Format'
import store from '@state/store'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { minhaCarteira, patrimonio_consolidado } from '@constants/URL'

class APIFinancialPlanningInvestmentPortfolio extends APITemplate {
  constructor() {
    super()
    this.reqCarregar = {}
  }

  _shouldSkipLoad(clientId, forceUpdate) {
    if (!clientId) {
      return { status: 400, message: 'Cliente não informado.' }
    }

    const storedClientId =
      store.getters['financialPlanning/investmentPortfolioClientId']

    if (!forceUpdate && String(storedClientId) === String(clientId)) {
      const shouldUpdate = diffTimeMinutes(
        store.getters['financialPlanning/investmentPortfolioLastUpdate'],
        MINUTES_TIMEOUT_REQUESTS
      )

      if (!shouldUpdate) {
        return store.getters['financialPlanning/investmentPortfolio']
      }
    }

    if (store.getters['financialPlanning/investmentPortfolioLoading']) {
      return store.getters['financialPlanning/investmentPortfolio']
    }

    return null
  }

  _handleResponse(response, clientId) {
    if (response && response.status === 200) {
      store.dispatch('financialPlanning/setInvestmentPortfolio', {
        data: response.value || response,
        clientId,
      })
    } else {
      store.dispatch('financialPlanning/setInvestmentPortfolio', null)
    }
  }

  async _executeCarregar(clientId, requestKey) {
    store.dispatch('financialPlanning/setInvestmentPortfolioLoading', true)
    const payload = { id_cliente: clientId }
    this.reqCarregar[requestKey] = con.post(minhaCarteira.posicao, payload)

    try {
      const response = await this.reqCarregar[requestKey]
      this._handleResponse(response, clientId)
      return response
    } catch (error) {
      this._handleResponse(null, clientId)
      throw error
    } finally {
      store.dispatch('financialPlanning/setInvestmentPortfolioLoading', false)
      delete this.reqCarregar[requestKey]
    }
  }

  async carregar({ clientId, forceUpdate = false } = {}) {
    const skipResult = this._shouldSkipLoad(clientId, forceUpdate)
    if (skipResult) return skipResult

    const requestKey = String(clientId)
    if (this.reqCarregar[requestKey]) {
      return this.reqCarregar[requestKey]
    }

    const response = await this._executeCarregar(clientId, requestKey)

    return response || {}
  }

  async carregarDadosCliente({ clientId } = {}) {
    if (!clientId) {
      return { status: 400, message: 'Cliente não informado.', value: '' }
    }
    const r = await con.post(minhaCarteira.avisos, { id_cliente: clientId })
    return r || { status: 500, message: 'Erro ao carregar dados do cliente.', value: '' }
  }

  async carregarPatrimonioConsolidado({ clientId }) {
    if (!clientId) {
      return null
    }

    const response = await con.get(patrimonio_consolidado.list({ clientId }))

    return response || {}
  }
}

const apiFinancialPlanningInvestmentPortfolio =
  new APIFinancialPlanningInvestmentPortfolio()

export { apiFinancialPlanningInvestmentPortfolio }
